import React from 'react';
import PropTypes from 'prop-types';

// utils
import { isCountryCounter } from "../../../utils";

// counts
import { LIVE_MUSIC, BAND, MUSICIAN, SERVICE } from "../../../consts";

// styles
import './PinCounterLabel.css';

const PinCounterLabel = ({ type, defaults, countryPinCount }) => {
    if (!countryPinCount || !isCountryCounter(type, defaults, countryPinCount.pinCount)) return null;

    let text = 'אירועים והופעות חיות';
    if (type === SERVICE) text = 'שירותי מוזיקה'
    if (type === BAND) text = 'להקות'
    if (type === MUSICIAN) text = 'מוזיקאים'

    return (
        <div className={`pin-counter-wrapper ${type}`}>
            <span className="country">{countryPinCount.country === 'Israel'  ? 'ישראל' : countryPinCount}</span>
            <span className="count">{countryPinCount.pinCount}</span>
            <span className="text">{text}</span>
        </div>
    )
};

PinCounterLabel.propTypes = {
    type: PropTypes.oneOf([LIVE_MUSIC, SERVICE, BAND, MUSICIAN]),
    defaults: PropTypes.object,
    countryPinCount: PropTypes.object
}

export default PinCounterLabel;



// WEBPACK FOOTER //
// ./src/Components/Elements/PinCounters/PinCounterLabel.js